/**
 * Represents a presigned S3 upload URL obtained from the backend.
 * Used for uploading files directly to S3.
 */
export class PresignedUploadModel {
  public uploadUrl!: string;
  public fileId!: string;
  public expiresIn!: number;
  public s3Key!: string; // S3 key needed for confirm step
  public requiredHeaders!: Record<string, string>; // Headers required for S3 PUT
}
